import { render, staticRenderFns } from "./brandSummary1.vue?vue&type=template&id=4ec45bc5&scoped=true&"
import script from "./brandSummary1.vue?vue&type=script&lang=js&"
export * from "./brandSummary1.vue?vue&type=script&lang=js&"
import style0 from "./brandSummary1.vue?vue&type=style&index=0&id=4ec45bc5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec45bc5",
  null
  
)

export default component.exports